import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import { Button, Steps } from 'antd';
import {ChooseBank} from "./ChooseBank";
import {Loader} from "./Loader";
import {DataInput} from "./DataInput";
import {Replenishment} from "./Replenishment";
import {setIsLoading} from "../../../../store/slices/AcquiringSlices/DataReducer";
import {Response} from "./Response";
import {getPaymentsMethodsP2P} from "../../../../ajax/services/accounts";
import s from "./P2P.module.css";
import './index.css'
export const P2P = () => {
    const dispatch = useDispatch();
    const location = useLocation()
    const {isLoading} = useSelector((store) => store.data);
    const token = useSelector((store) => store.authP2P.token);
    const [current, setCurrent] = useState(0);
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [methodId, setMethodId] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false)
    const [data, setData] = useState({
        amount: '',
        name: ''
    })
    const methods = useSelector(store => store.accountP2P.methods.methods)
    const selectedCard = useMemo(
        () => methods?.find((el) => el.id === selectedCardId),
        [selectedCardId, methods]
    );
    const next = () => {
        dispatch(setIsLoading(true))
        setCurrent(current + 1);
        setTimeout(() => {
            dispatch(setIsLoading(false))
        }, 2000);
    };
    const prev = () => {
        setCurrent(current - 1);
    };
    const start = () => {
        setCurrent(current - 3);
    }
    const steps = [
        {
            title: '01',
            content: <ChooseBank selectedCard={selectedCard} setMethodId={setMethodId} selectedCardId={selectedCardId} setSelectedCardId={setSelectedCardId} next={next} />,
        },
        {
            title: '02',
            content: <DataInput methodId={methodId} data={data} setData={setData} prev={prev} next={next} selectedCardId={selectedCardId}/>,
        },
        {
            title: '03',
            content: <Replenishment selectedCard={selectedCard} selectedCardId={selectedCardId} data={data} setData={setData} setIsSuccess={setIsSuccess} prev={prev} next={next} />,
        },
        {
            title: '04',
            content: <Response isSuccess={isSuccess} />,
        },
    ];

    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        marginTop: 50,
        fontSize: 20,
        color: '#ABABAB',
        fontFamily: 'Cera Pro',
    };

    useEffect(() => {
        if (location.pathname.includes('/api/p2p')) {
            dispatch(setIsLoading(false))
            return;
        }
        dispatch(getPaymentsMethodsP2P(token));
        setSelectedCardId(null)
    }, []);

    return (
        <div className={s.wrap}>
            <Steps current={current} items={items} progressDot={true}/>
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                }}
            >
                {(current > 0 && current < 3 ) &&
                    <Button
                        style={{
                            margin: '0 8px',
                        }}
                        onClick={() => prev()}
                    >
                        Назад
                    </Button>
                }
                {isLoading &&
                    <div className={s.loader}><Loader /></div>}
                {current === steps.length - 1 && (
                    <Button type="primary" onClick={() => start()}>
                        В начало
                    </Button>
                )}
            </div>
        </div>
    )
}
